<template>
    <el-button type="danger" size="small" v-bind="$attrs" v-on="$listeners">
        <jj-icons type='delete' />
        <slot>
            {{ $t('common.delete') }}
        </slot>
    </el-button>
</template>
<script>
export default {
    name: 'ButtonDelete'
}
</script>